import { MDSTag, MDSTagProps } from '@marqvision/mds-v2';

type Props = {
  color: MDSTagProps['color'];
  children: string;
};

export const SelectedTag = (props: Props) => {
  const { color = 'bluegray', children: label } = props;

  return (
    <MDSTag size="small" variant="tint" color={color}>
      {label}
    </MDSTag>
  );
};
